<template>
  <Modal>
    <Modal.Media class="bg-white!">
      <img
        :src="MaintenanceImage"
        :width="MAINTENANCE_IMAGE_WIDTH"
        :height="MAINTENANCE_IMAGE_HEIGHT"
        alt=""
        class="transition-opacity duration-200"
        :class="imageLoaded ? 'opacity-100' : 'opacity-0'"
        @load="imageLoaded = true"
      />
    </Modal.Media>

    <Modal.Title>Under maintenance</Modal.Title>
    <Modal.Body class="text-gray-600!">
      Dacr is currently undergoing maintenance. This message will disappear when
      it’s completed.
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Modal } from '@dacr/library'

import MaintenanceImage from '@/assets/images/maintenance.png'

const MAINTENANCE_IMAGE_WIDTH = 1464
const MAINTENANCE_IMAGE_HEIGHT = 762

const imageLoaded = ref(false)
</script>
